import type { GameDescriptor } from '@everyturn/engine/runtime';

export const layoutPreviewDescriptor = {
  gameId: 'layout-preview',
  displayName: 'Layout Preview (LLM)',
  seats: ['viewer'],
  minPlayers: 1,
  maxPlayers: 1,
  defaultSeat: 'viewer',
} as const satisfies GameDescriptor;
